<template>
   <div class="row">
            <div class="col-sm-12">
                <b-card bg-variant="white">
                    <LoadingSpinner v-if="isLoading"/>
                    <Alerts />
                    <UserModal :key="shownUser.id" ref="userModal" v-if="shownUser" :user="shownUser"></UserModal>

                    <v-client-table ref="users_table" :columns="columns" :data="users" :options="options">
                        <div slot="beforeTable">
                            <div class="form-group form-inline pull-right">
                                <b-dropdown class="mx-1" right text="Export as">
                                    <b-dropdown-item @click="exportUsers('csv')">CSV</b-dropdown-item>
                                    <b-dropdown-item @click="exportUsers('xls')">XLS</b-dropdown-item>
                                    <b-dropdown-item @click="exportUsers('pdf')">PDF</b-dropdown-item>
                                </b-dropdown>
                    
                            </div>
                        </div>


                        <div slot="filter_id" slot-scope="props">
                            <b-checkbox :value="props.row.id" v-model="selected"></b-checkbox>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                        </div> 

                        <div slot="balance" slot-scope="props">
                          {{ formatBalance(props.row.balance) }}
                        </div>

                        <div slot="marketplaces" slot-scope="props" class="marketplace-logos">

                            <span v-for="marketplace in getRowMarketplaces(props.row)" :key="marketplace.code">
                              <b-img :src="`/images/integrations/${marketplace.code}/table-icon.png`" class="marketplace-logo" />
                            </span>
                          
                        </div>

                        <div slot="actions" slot-scope="props">
                          <b-btn class="btn btn-primary btn-sm view" @click="viewUser(props.row.id)">View</b-btn>
                        </div>

                    </v-client-table>
                </b-card>
            </div>
   </div>
</template>

<style lang="scss" scoped>
.marketplace-logos {
  flex-wrap: nowrap;

  span + span {
    margin-left: 5px;
  }
}
.marketplace-logo {
  display: inline-block;
  max-width: 65px;
  height: auto;
}
</style>
<script>
import numeral from 'numeral';
import LoadingSpinner from '../../components/LoadingSpinner';
import Alerts from '../../components/Alerts';
import UserModal from './UserModal';

export default {
  components: {
    LoadingSpinner,
    Alerts,
    UserModal
  },
  props: [],
  mounted() {
    this.fetchUsers();
  },
  data() {
    return {
      isLoading: false,
      users: [],
      selected: [],
      shownUser: null,
      columns: [
        'filter_id',
        'name',
        'company',
        'email',
        'phone',
        'marketplaces',
        'balance',
        'actions'
      ],
      options: {
        headings: {
          filter_id: ''
        },
        sortable: ['name', 'company', 'email', 'phone', 'balance'],
        filterable: ['name', 'company', 'email', 'phone'],
        columnsDropdown: true,
        texts: {
          filterPlaceholder: 'Search'
        }
      }
    };
  },
  computed: {
    /*
    userTableOptions() {
      return this.users.map((user) => {
        return {
          value: user.id
        }
      })
    }*/
  },
  methods: {
    formatBalance(balance) {
      return numeral(balance).format('$0,0.00');
    },
    fetchUsers() {
      this.isLoading = true;
      axios.get('/admin/users').then(response => {
        this.users = response.data.users;
        this.isLoading = false;
      });
    },
    getRowMarketplaces(row) {
      if (!row.integrations) {
        return [];
      }
      return row.integrations
        .filter(integration => {
          return integration.active;
        })
        .map(integration => {
          return integration.marketplace;
        });
    },
    viewUser(userId) {
      this.isLoading = true;
      axios.get('/admin/users/' + userId).then(response => {
        this.shownUser = response.data;
        this.isLoading = false;
      });
    },
    exportUsers(type) {
      let vm = this;
      vm.isLoading = true;

      axios
        .get(`/admin/users/export/${type}`)
        .then(response => {
          window.open(response.data.url);
        })
        .finally(() => {
          vm.isLoading = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Admin/Users.vue